import { Item } from '../types/Item';

export const items: Item[] = [
  { date: new Date(2022, 9, 24), category: 'food', title: 'Giraffas', value: 32.12 },
  { date: new Date(2022, 9, 24), category: 'food', title: 'Grilleto', value: 30 },
  { date: new Date(2022, 10, 16), category: 'rent', title: 'Aluguel Casa', value: 32.12 },
  { date: new Date(2022, 8, 20), category: 'salary', title: 'Salário MELI', value: 5400 },
];
